export var Textarea = {
  variants: {
    outline: {
      borderColor: 'grey.500',
      borderRadius: 'sm',
      letterSpacing: '-0.2px',
      padding: '10px 12px',
      maxHeight: '31.25rem',
      _placeholder: {
        color: 'grey.800'
      },
      _focus: {
        borderColor: 'blue.900',
        outline: '1px solid #00CAFF',
        boxShadow: '0 0 3px 2px #2182EB'
      },
      _disabled: {
        bg: 'grey.100',
        borderColor: 'grey.200',
        color: 'grey.800'
      },
      _invalid: {
        borderWidth: '2px',
        borderColor: 'red.700',
        boxShadow: 'none',
        _focus: {
          borderColor: 'red.700',
          boxShadow: '0 0 4px 1px #D0011C',
          outline: 'none'
        }
      }
    }
  }
};